import EnumSet from 'Services/enumSet';

interface ICompanyStatus extends EnumSet {
  companyIncompleteCheckout: number,
  companyHasOverdueInvoice: number,
  companyUnableCompleteSubscription: number,
  waitingPayment: number,
  accountWillBeBlocked: number,
  blockedAccount: number,
}

const companyStatus = new EnumSet({
  none: { value: 0, description: 'Não há notificações' },
  companyIncompleteCheckout: { value: 1, description: 'Empresa não completou o checkout' },
  companyHasOverdueInvoice: { value: 2, description: 'Empresa possui fatura em atraso' },
  companyUnableCompleteSubscription: { value: 3, description: 'A empresa não conseguiu concluir a assinatura (entre 5 e 10 dias)' },
  downgradedPlan: { value: 4, description: 'A empresa mudou para um plano inferior (downgrade)' },
  waitingPayment: { value: 5, description: 'Aguardando pagamento' },
  accountWillBeBlocked: { value: 6, description: 'A conta será bloqueada' },
  blockedAccount: { value: 7, description: 'A conta está bloqueada' },
}) as ICompanyStatus;

export default companyStatus;
